<template>
  <div class="purchase-card">
    <div>
      <img
          class="card-icon"
          :src="require('@/static/index/purchase/card-icon.png')"
          alt="描述背景"
      />
      <div class="text-icon">接受报价中</div>
    </div>

    <div class="top-inner">
      <div class="goods-image-box">
        <img
            v-if="data.product"
            class="goods-image"
            :src="data.product.image"
            alt="商品图片"
        />
      </div>
      <div class="card-title">{{ data.product_name }}</div>
      <div class="card-info">
        <span class="card-info-cas">{{ data.cas_no }}</span>
        <span class="card-info-wait">{{ data.number }}{{ data.unit }}</span>
        <span v-if="data.invoice_type == 1"> 专票(13%) </span>
        <span v-else> 普票 </span>
      </div>
      <div class="card-time">
        询单有效期：{{ data.begin_at }} - {{ data.end_at }}
      </div>
    </div>
    <div class="card-footer">
      <span class="card-footer-text"
      >已有<span class="card-footer-text-num">{{ data.quote_count }}</span>
        家供应商已报价</span
      >
      <div></div>
      <gradient-buttion @hit="goQuote" height="30px">我要报价</gradient-buttion>
    </div>
  </div>
</template>
<script>
import gradientButtion from "@/components/button/gradient-button.vue";

export default {
  name: "purchase-card",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {gradientButtion},
  computed: {
    isLogin() {
      return this.$store.getters.isLogin;
    },
  },
  methods: {
    goQuote() {
      if (!this.mixCheckLogin() || !this.mixCheckUserMobile()) {
        return;
      }
        this.$emit('show', this.data)
    }
  },
};
</script>
<style lang="scss" scoped>
.purchase-card {
  position: relative;
  width: 316px;
  height: 310px;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #d8d8d8;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  .card-icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 120px;
    height: 35px;
  }

  .text-icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 120px;
    height: 33px;
    z-index: 1;
    font-weight: 400;
    font-size: var(--font-size-default-14);
    color: #f8bb7d;
    text-align: center;
    line-height: 30px;
  }

  .top-inner {
    text-align: center;
    padding: 24px 20px 0;

    .goods-image-box {
      width: 100%;
      height: 131px;
      text-align: center;

      .goods-image {
        width: 80%;
        height: 131px;
        object-fit: contain;
      }
    }

    .card-title {
      font-weight: bold;
      font-size: var(--font-size-default-16);
      color: #424242;
      line-height: 28px;
    }

    .card-info {
      display: flex;
      justify-content: space-between;
      font-weight: 400;
      font-size: var(--font-size-default-14);
      color: #5f616c;
      margin: 6px 0 12px;

      .card-info-cas {
        background: #EEF2F7;
        color: #4A5568;
        font-size: 12px;
        padding: 2px 8px;
        border-radius: 20px;
        font-family: monospace;
      }

      .card-info-wait {
        width: 35%;
        border-left: 1px solid #afafaf;
        border-right: 1px solid #afafaf;
      }
    }

    .card-time {
      font-weight: 400;
      font-size: var(--font-size-default-14);
      color: #afafaf;
    }
  }

  .card-footer {
    padding: 0px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .card-footer-text {
      font-weight: 400;
      font-size: var(--font-size-default-14);
      color: #00112b;

      .card-footer-text-num {
        color: #fe3c3c;
        font-weight: bold;
        font-size: 18px;
      }
    }

    .card-footer-button {
      width: 118px;
      height: 30px;
      background: rgba(12, 96, 230, 0.1);
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #2979f1;
      font-weight: 400;
      font-size: var(--font-size-default-14);
      color: #0c60e6;
      text-align: center;
      line-height: 30px;
    }
  }
}
</style>
